export class GridData {
    col1: any;
    col2: any;
    col3: any;
    col4: any;
    col5: any;
    col6: any;
}
